import SkeletonTable from "@/components/SkeletonTable"
import { getListLayananPlaza } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import { Link, useLocation } from "react-router-dom"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

const listMenu = [
  {
    name: "Layanan Plaza",
    path: "/admin/master/layanan-plaza",
  },
  {
    name: "Sub Layanan 1",
    path: "/admin/master/layanan-plaza/sub-layanan-1",
  },
  {
    name: "Sub Layanan 2",
    path: "/admin/master/layanan-plaza/sub-layanan-2",
  },
  {
    name: "Sub Status",
    path: "/admin/master/layanan-plaza/sub-status",
  },
]

export default function MasterLayananPlazaPage() {
  const { pathname } = useLocation()

  const { data, isPending } = useQuery({
    queryKey: ["listLayananPlaza"],
    queryFn: getListLayananPlaza,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                        ? "rounded-l-full"
                        : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          )
        })}
      </div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
